InviteTab = App.loadClass "grower::handlers/contacts/tabs/Invite_Tab_Handler"

class exports.Edit_Permission_Dialog extends DialogHandler

    afterSave: (json) ->
        ths = this
        writer = ths.dialog.find('.message_writer')

        o = json.status.msg
        if json.status.type isnt "success"
            o += '<ul>'
            for k, v of json.data.messages
                o += "<li>#{v}</li>"
            o += "</ul>"

        writer.message_writer(json.status.type, o)

        if json.status.type is "success"

            ## Update DDMs ##
            sel = ths.dialog.find('.sel-edit-permission')
            if(json.data.new_title)
                options = sel.children('option').each( () ->
                    if($(this).val() is json.data.permission_id)
                        $(this).html(json.data.new_title)
                )
                for i, v of App.current_page.activeSubHandlers
                    if(v instanceof InviteTab)
                        $(v.layoutSelector).find('.btn-search').click() #re-run search
                    else
                        App.current_page.refreshSubHandlers()
            ths.dialog.find('.sel-edit-permission').val('')

            ## Set Dialog to Begining State ##
            writer.message_writer('hide')

            #ths.dialog.find('#frm_editpermission').hide()
            #ths.dialog.find('.save-btn').hide()

            #ths.closeDialog()
            # console.log(ths.dialog.find('form'))
            ths.dialog.find('form').slideUp()

            setTimeout () =>
                ths.destroy()
            , 2000

        else
            ths.errorAction(json)


    init: () ->
        ths = this
        @layoutUrl = 'backend/grower/contacts/editpermissionform'
        @classes = 'large_dialog'
        @saveUrl = 'backend/grower/contacts/editpermission-ajax'
        @refreshNavHandler = false

        @createDialog()


    afterLoadLayout: () ->
        self = this
        @openDialog()

        @dialog.find('.sel-edit-permission').change () ->
            id = $(this).val()
            if id is ''
                self.dialog.find('#frm_editpermission').hide()
                self.dialog.find('.save-btn').hide()
                self.setPosition()
            else
                self.getPermission id, () ->
                    self.setPosition()
                self.dialog.find('.save-btn').show()


        @dialog.find('.save-btn').hide()

        @submitAction = () =>
            valid = @dialog.find("#frm_editpermission").validationEngine('validate')
            if valid
                @save("Saving...")


    getPermission: (id, callback = null) ->
        @dialog.find('.message_writer').message_writer('info', 'Loading...')

        $.post 'backend/grower/contacts/get-permissionform-ajax', id: id, (response) =>
            cdata = response.data

            @dialog.find('.permission-title').val(cdata.title)
            @dialog.find('.permission-id').val(cdata.id)
            render = @dialog.find(".permissions-template").render(cdata)
            @dialog.find('.permissions-table-wrapper').html(render)

            @dialog.find('#frm_editpermission').show()

            @dialog.find('#frm_editpermission').validationEngine
                promptPosition: "centerRight",
                ajaxFormValidationMethod: "POST"

            @dialog.find('.message_writer').message_writer('success', 'Loaded')
            @dialog.find('.message_writer').message_writer('hide')

            ## View and Add, select or deselect entire columns ##
            @dialog.find('.multi-control').click (e) ->
                if $(this).is('.view')
                    affectClass = '.con_addView'
                else if $(this).is('.add')
                    affectClass = '.con_addAdd'
                affect = affectClass + " :checkbox"

                table = $(this).parents('table')
                checkboxes = $(table).find(affect)

                unchecked = false
                checkboxes.each () ->
                    if not $(this).prop('checked')
                        unchecked = true
                        $(this).prop('checked', true)
                    else

                if not unchecked
                    checkboxes.each () ->
                        $(this).prop('checked', false)

            @afterPermissionLoaded()


    afterPermissionLoaded: () ->
        @setPosition()
